<div
  class="modal fade animate-fade"
  id="AmendmentsAppDetails"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="AmendmentsAppDetailsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="AmendmentsAppDetailsLabel">
          Preview file
        </h1>
        <div class="d-flex align-items-center gap-2">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            *ngIf="previewDocument"
            (click)="downloadDocument(previewDocument)"
          >
            <i class="bi bi-download me-1"></i>
            Download
          </button>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="close()"
          ></button>
        </div>
      </div>
      <div class="modal-body">
        <iframe
          [src]="base64Pdf"
          style="width: 100%; height: 60vh; margin: 0 auto"
        ></iframe>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid">
  <!-- <div class="row mb-1">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <h4 class="fw-bold ">  <i class="bi bi-file-earmark-plus"></i>

        📝 Amendments</h4>
      
    </div>
  </div> -->

  <form [formGroup]="amendmentForm">
    <div class="card">
      <div class="card-header">
        <h5 class="election-title">📝 Amendments</h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <!-- File Upload Fields -->
          <!-- <ng-container *ngFor="let fileInput of fileInputs">
            <div class="col-lg-4 col-md-6">
              <label class="form-label">{{ fileInput.label }}
                <span class="text-danger">* </span></label>
              <input type="file" class="form-control" formControlName="{{fileInput.key}}"
                [class]="(amendmentForm.get(fileInput.key)?.dirty && amendmentForm.get(fileInput.key)?.invalid)?'invalid':''"
                (change)="onFileSelected($event, fileInput.key)">
              <sup>(<span class="text-danger">max
                  size:</span> 2 MB, <span class="text-danger">formats:</span>
                pdf)</sup>
              <div *ngIf=" amendmentForm.get(fileInput.key)?.dirty && amendmentForm.get(fileInput.key)?.invalid"
                class="invalid-section">
                Please upload file {{fileInput.label}}

              </div>
            </div>
          </ng-container> -->

          <ng-container *ngFor="let fileInput of fileInputs; let i = index">
            <div class="col-lg-4 col-md-6">
              <label class="form-label">
                {{ fileInput.label }} <span class="text-danger">*</span>
              </label>

              <!-- ✅ ALWAYS keep input -->
              <input
                type="file"
                class="form-control file-upload-input"
                id="fileInput.key"
                #fileInputRef
                (change)="onFileSelected($event, fileInput.key)"
              />
              <small class="file-upload-hint d-block"
                >(<span class="text-danger">max size:</span> 2 MB,
                <span class="text-danger">formats:</span> pdf)</small
              >
              <!-- View selected / existing upload (1968 society apply) -->
              <a
                *ngIf="canShowFileView(fileInput.key)"
                href="javascript:void(0)"
                class="file-view-link"
                data-bs-toggle="modal"
                data-bs-target="#AmendmentsAppDetails"
                (click)="preview(amendmentForm.get(fileInput.key)?.value)"
              >
                <i class="fa fa-eye" aria-hidden="true"></i>
                <span>View</span>
              </a>
              <!-- ✅ Replace button -->
              <!-- <button *ngIf="amendmentForm.get(fileInput.key)?.value?.path"
      type="button"
      class="btn btn-sm btn-warning mt-1"
      (click)="triggerFileInput(i)">
      Replace
    </button> -->
            </div>
          </ng-container>
          <!-- Dropdown Fields -->
          <div class="col-lg-4 col-md-6">
            <label class="form-label"
              >Amendment Type<span class="text-danger">* </span></label
            >
            <select
              class="form-control"
              formControlName="amendmentType"
              (change)="onAmmendmentTypeChange($event)"
            >
              <option value="" selected>Select Type</option>
              <option value="1">Add</option>
              <option value="2">Change</option>
              <option value="3">Remove</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <!-- Conditional Section -->
    <div *ngIf="amendmentForm.get('amendmentType')?.value">
      <div class="card shadow-sm mb-1">
        <div class="card-header">
          <h5 class="election-title">🧾 Amendment Details</h5>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <!-- <div class="col-lg-4 col-md-6">
              <label class="form-label">Liabilities<span class="text-danger">* </span></label>
              <select class="form-control" formControlName="liabilities" (change)="onLiabilitiesChange($event)">
                <option value="" disabled selected>Select Liabilities</option>
                <option value="1">Yes</option>
                <option value="2">No</option>
              </select>
            </div> -->
            <div class="col-lg-4 col-md-6">
              <label class="form-label"
                >Total Members in Society<span class="text-danger"
                  >*
                </span></label
              >
              <input
                type="text"
                class="form-control"
                formControlName="stotalmember"
                placeholder="Enter Total Members in Society"
                maxlength="8"
                (keypress)="validateNumber($event)"
                (paste)="validatePaste($event)"
              />
              <div
                *ngIf="
                  amendmentForm.controls['stotalmember'].invalid &&
                  amendmentForm.controls['stotalmember'].dirty
                "
                class="text-danger small"
              >
                Max 8 Numbers (Only numbers are allowed.)
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <label class="form-label"
                >Members present and voted<span class="text-danger"
                  >*
                </span></label
              >
              <input
                type="text"
                class="form-control"
                formControlName="presentvoted"
                placeholder="Enter Members present and voted"
                maxlength="8"
                (keypress)="validateNumber($event)"
                (paste)="validatePaste($event)"
              />
              <div
                *ngIf="
                  amendmentForm.controls['presentvoted'].invalid &&
                  amendmentForm.controls['presentvoted'].dirty
                "
                class="text-danger small"
              >
                Max 8 Numbers (Only numbers are allowed.)
              </div>
            </div>

            <div class="col-md-4 mb-2">
              <label class="form-label m-0">Amendment In</label
              ><span class="text-danger">* </span>
              <select
                class="form-control"
                formControlName="sAmmendmentTypeSubject"
                (change)="onAmendmentTypeChange($event)"
              >
                <option value="">Select Amendment</option>
                <option *ngFor="let item of AmendmentType" [value]="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>

            <div class="col-lg-4 col-md-6" *ngIf="isPriorApprovalDocument">
              <label class="form-label"
                >Prior Approval From Registrar<span class="text-danger"
                  >*
                </span></label
              >
              <input
                type="file"
                class="form-control"
                formControlName="priorApprovalRegistrar"
                [class]="
                  amendmentForm.get('priorApprovalRegistrar')?.dirty &&
                  amendmentForm.get('priorApprovalRegistrar')?.invalid
                    ? 'invalid'
                    : ''
                "
                (change)="onFileSelected($event, 'priorApprovalRegistrar')"
              />
              <small class="file-upload-hint d-block"
                >(<span class="text-danger">max size:</span> 2 MB,
                <span class="text-danger">formats:</span> pdf)</small
              >
              <a
                *ngIf="canShowFileView('priorApprovalRegistrar')"
                href="javascript:void(0)"
                class="file-view-link"
                data-bs-toggle="modal"
                data-bs-target="#AmendmentsAppDetails"
                (click)="preview(amendmentForm.get('priorApprovalRegistrar')?.value)"
              >
                <i class="fa fa-eye" aria-hidden="true"></i>
                <span>View</span>
              </a>
            </div>
            <div
              class="col-lg-4 col-md-6"
              *ngIf="
                selectedAmendmentName === 'Name' ||
                selectedAmendmentName === 'Address'
              "
            >
              <label class="form-label"
                >Registration Certificate<span class="text-danger"
                  >*
                </span></label
              >
              <input
                type="file"
                class="form-control"
                formControlName="registrarCertificate"
                [class]="
                  amendmentForm.get('registrarCertificate')?.dirty &&
                  amendmentForm.get('registrarCertificate')?.invalid
                    ? 'invalid'
                    : ''
                "
                (change)="onFileSelected($event, 'registrarCertificate')"
              />
              <small class="file-upload-hint d-block"
                >(<span class="text-danger">max size:</span> 2 MB,
                <span class="text-danger">formats:</span> pdf)</small
              >
              <a
                *ngIf="canShowFileView('registrarCertificate')"
                href="javascript:void(0)"
                class="file-view-link"
                data-bs-toggle="modal"
                data-bs-target="#AmendmentsAppDetails"
                (click)="preview(amendmentForm.get('registrarCertificate')?.value)"
              >
                <i class="fa fa-eye" aria-hidden="true"></i>
                <span>View</span>
              </a>
            </div>

            <div class="col-lg-4 col-md-6">
              <label class="form-label"
                >Bye-laws Number <span class="text-danger">* </span></label
              >
              <input
                type="text"
                class="form-control"
                formControlName="bylawsNumber"
                placeholder="Enter Bye-Laws Number"
                maxlength="8"
                (keypress)="validateAlphanumeric($event)"
                (paste)="validateAlphanumericPaste($event)"
              />
              <div
                *ngIf="
                  amendmentForm.controls['bylawsNumber'].invalid &&
                  amendmentForm.controls['bylawsNumber'].dirty
                "
                class="text-danger small"
              >
                Max 8 characters (Only alphanumeric characters are allowed.)
              </div>
            </div>

            <!-- Existing Bye-laws Details hidden: do not show/prefill all society bylaws -->
            <!--
            <div class="col-12" *ngIf="isExistingBylaws">
              <label class="form-label"
                >Existing Bye-laws Details<span class="text-danger"
                  >*
                </span></label
              >
              <div class="textarea-wrapper">
                <textarea
                  rows="3"
                  class="form-control"
                  formControlName="existingBylawsDetails"
                  [class]="
                    amendmentForm.get('existingBylawsDetails')?.dirty &&
                    amendmentForm.get('existingBylawsDetails')?.invalid
                      ? 'invalid'
                      : ''
                  "
                  placeholder="Enter Existing Bye-laws Details"
                  #existText
                  maxlength="1200"
                ></textarea>
                <div class="char-counter" suffix>
                  {{ existText.value.length }} / {{ existText.maxLength }}
                </div>
              </div>
            </div>
            -->
            <div
              class="col-12 row"
              *ngIf="amendmentForm.get('sAmmendmentTypeSubject')?.value == 7"
            >
              <!-- Area of Operation -->
              <div class="mb-2 col-lg-4 col-md-6">
                <label
                  >Area of Head Office <span class="text-danger">*</span></label
                >
                <select
                  class="form-select"
                  formControlName="iAreaOperation"
                  (change)="onChangeAoP()"
                >
                  <option value="">Select</option>
                  <option
                    *ngFor="let item of operationAreaList"
                    [value]="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <div
                  class="text-danger"
                  *ngIf="
                    amendmentForm.get('iAreaOperation')?.touched &&
                    amendmentForm.get('iAreaOperation')?.invalid
                  "
                >
                  Area of Operation is required.
                </div>
              </div>
              <!-- Address -->
              <div class="mb-2 col-lg-4 col-md-6">
                <label>Address<span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="address"
                  [class]="
                    amendmentForm.get('address')?.dirty &&
                    amendmentForm.get('address')?.invalid
                      ? 'invalid'
                      : ''
                  "
                  placeholder="Enter Address"
                />
                <div
                  class="text-danger"
                  *ngIf="
                    amendmentForm.get('address')?.touched &&
                    amendmentForm.get('address')?.invalid
                  "
                >
                  address is required.
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mb-2">
                <label class="mb-1 text-dark"
                  >Division<span class="text-danger">*</span></label
                >
                <select
                  class="form-select"
                  formControlName="iDivisionId"
                  [ngClass]="{
                    'invalid-input': amendmentForm.get('iDivisionId')?.errors,
                  }"
                  (change)="getDistrict($event)"
                >
                  <option value="0">Select Division</option>
                  <option *ngFor="let item of divisionList" [value]="item.id">
                    {{ item.name }}
                  </option>
                </select>
                <div
                  *ngIf="
                    amendmentForm.get('iDivisionId')?.touched &&
                    amendmentForm.get('iDivisionId')?.errors
                  "
                >
                  <!-- <small class="text-danger" *ngIf="societyDetailForm.get('iDivisionId')?.errors?.['min']">
                        Division is required.
                      </small> -->
                </div>
              </div>
              <!-- District -->
              <div class="mb-2 col-lg-4 col-md-6">
                <label>District <span class="text-danger">*</span></label>
                <select
                  class="form-select"
                  formControlName="iDistrictId"
                  (change)="onDistrictChange($event)"
                >
                  <option value="0">Select District</option>
                  <option *ngFor="let d of districtList" [value]="d.id">
                    {{ d.name }}
                  </option>
                </select>
                <div
                  class="text-danger"
                  *ngIf="
                    amendmentForm.get('iDistrictId')?.touched &&
                    amendmentForm.get('iDistrictId')?.invalid
                  "
                >
                  District is required.
                </div>
              </div>

              <!-- Circle -->
              <div class="mb-2 col-lg-4 col-md-6">
                <label>Circle <span class="text-danger">*</span></label>
                <select
                  class="form-select"
                  formControlName="iCircleid"
                  (change)="getBlock($event)"
                >
                  <option value="0">Select Circle</option>
                  <option *ngFor="let c of circleList" [value]="c.id">
                    {{ c.name }}
                  </option>
                </select>
                <div
                  class="text-danger"
                  *ngIf="
                    amendmentForm.get('iCircleid')?.touched &&
                    amendmentForm.get('iCircleid')?.invalid
                  "
                >
                  Circle is required.
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mb-2">
                <label class="mb-1 text-dark"
                  >Block<span class="text-danger">*</span></label
                >
                <select
                  class="form-select"
                  formControlName="iBlockid"
                  [ngClass]="{
                    'invalid-input': amendmentForm.get('iBlockid')?.errors,
                  }"
                  (change)="getPanchayat($event)"
                >
                  <option value="0">Select Block</option>
                  <option *ngFor="let item of blockList" [value]="item.id">
                    {{ item.name }}
                  </option>
                </select>
                <div
                  *ngIf="
                    amendmentForm.get('iBlockid')?.touched &&
                    amendmentForm.get('iBlockid')?.errors
                  "
                >
                  <!-- <small class="text-danger" *ngIf="societyDetailForm.get('iBlockid')?.errors?.['min']">
                        Block is required.
                      </small> -->
                </div>
              </div>
              <!-- Subdivision -->
              <!-- <div class="mb-2 col-lg-4 col-md-6">
    <label>Subdivision <span class="text-danger">*</span></label>
    <select class="form-select" formControlName="subDivisionId">
      <option value="0">Select Subdivision</option>
      <option *ngFor="let s of subdivisionList" [value]="s.id">{{s.name}}</option>
    </select>
    <div class="text-danger" *ngIf="(amendmentForm.get('subDivisionId')?.touched ) && amendmentForm.get('subDivisionId')?.invalid">
      Subdivision is required.
    </div>
  </div> -->

              <!-- Conditional Local Body & Ward -->
              <div
                *ngIf="selectedAoP == 7 || selectedAoP == 93"
                class="mb-2 col-lg-4 col-md-6"
              >
                <label>Local Body <span class="text-danger">*</span></label>
                <select
                  class="form-select"
                  formControlName="iLocalBody"
                  (change)="getWards($event)"
                >
                  <option value="0">Select Local Body</option>
                  <option *ngFor="let lb of localBodyList" [value]="lb.id">
                    {{ lb.name }}
                  </option>
                </select>
                <div
                  class="text-danger"
                  *ngIf="
                    amendmentForm.get('iLocalBody')?.touched &&
                    amendmentForm.get('iLocalBody')?.invalid
                  "
                >
                  Local Body is required.
                </div>
              </div>

              <div
                *ngIf="selectedAoP == 7 || selectedAoP == 93"
                class="mb-2 col-lg-4 col-md-6"
              >
                <label>Ward <span class="text-danger">*</span></label>
                <select class="form-select" formControlName="iWard">
                  <option value="0">Select Ward</option>
                  <option *ngFor="let w of wardList" [value]="w.id">
                    {{ w.name }}
                  </option>
                </select>
                <div
                  class="text-danger"
                  *ngIf="
                    amendmentForm.get('iWard')?.touched &&
                    amendmentForm.get('iWard')?.invalid
                  "
                >
                  Ward is required.
                </div>
              </div>

              <!-- Conditional Panchayat & Village -->
              <div
                *ngIf="selectedAoP == 8 || selectedAoP == 93"
                class="mb-2 col-lg-4 col-md-6"
              >
                <label>Panchayat <span class="text-danger">*</span></label>
                <ng-multiselect-dropdown
                  [placeholder]="'Select Punchayat'"
                  [data]="panchayatList"
                  formControlName="iPanchayat"
                  [settings]="dropdownSettings"
                  (onSelect)="getVillage($event)"
                  (onDeSelect)="getVillage($event)"
                  (onSelectAll)="getVillage($event)"
                  (onDeSelectAll)="getVillage($event)"
                >
                </ng-multiselect-dropdown>
                <div
                  class="text-danger"
                  *ngIf="
                    amendmentForm.get('iPanchayat')?.touched &&
                    amendmentForm.get('iPanchayat')?.invalid
                  "
                >
                  Panchayat is required.
                </div>
              </div>

              <div
                *ngIf="selectedAoP == 8 || selectedAoP == 93"
                class="mb-2 col-lg-4 col-md-6"
              >
                <label>Village <span class="text-danger">*</span></label>
                <ng-multiselect-dropdown
                  [placeholder]="'Select Village'"
                  [data]="villageList"
                  formControlName="iVillage"
                  [settings]="dropdownSettings"
                >
                </ng-multiselect-dropdown>
                <div
                  class="text-danger"
                  *ngIf="
                    amendmentForm.get('iVillage')?.touched &&
                    amendmentForm.get('iVillage')?.invalid
                  "
                >
                  Village is required.
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mb-2">
                <label class="mb-1 text-dark"
                  >Enter Pincode<span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter Pincode"
                  formControlName="sPincode"
                  [minlength]="6"
                  [maxlength]="6"
                  (keypress)="allowOnlyNumbers($event)"
                />
                <div
                  *ngIf="
                    amendmentForm.get('sPincode')?.invalid &&
                    amendmentForm.get('sPincode')?.touched
                  "
                >
                  <!-- <small class="text-danger" *ngIf="societyDetailForm.get('sPincode')?.errors?.['required']">Pincode
                        required.</small> -->
                  <small
                    class="text-danger"
                    *ngIf="amendmentForm.get('sPincode')?.errors?.['pattern']"
                    >Invalid Pincode.</small
                  >
                  <small
                    class="text-danger"
                    *ngIf="amendmentForm.get('sPincode')?.errors?.['minlength']"
                    >fixed 6 characters required.</small
                  >
                </div>
              </div>
            </div>
            <!-- Common Wrapper -->
            <ng-container
              *ngIf="amendmentForm.get('sAmmendmentTypeSubject')?.value == 8"
            >
              <!-- Society Kind -->
              <div class="col-lg-4 col-md-6 mb-2">
                <label class="form-label">
                  Society Kind <span class="text-danger">*</span>
                </label>

                <select
                  class="form-select"
                  formControlName="iSKindid"
                  [ngClass]="{
                    'is-invalid':
                      amendmentForm.get('iSKindid')?.invalid &&
                      amendmentForm.get('iSKindid')?.touched,
                  }"
                  (change)="onSocietyKindChange($event)"
                >
                  <option value="">Select Society Kind</option>

                  <option
                    *ngFor="let item of societyKindList"
                    [value]="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>

                <div
                  class="invalid-feedback"
                  *ngIf="
                    amendmentForm.get('iSKindid')?.invalid &&
                    amendmentForm.get('iSKindid')?.touched
                  "
                >
                  Society Kind is required.
                </div>
              </div>

              <!-- Society Type -->
              <div class="col-lg-4 col-md-6 mb-2">
                <label class="form-label">
                  Society Type <span class="text-danger">*</span>
                </label>

                <select
                  class="form-select"
                  formControlName="iSTypeid"
                  [ngClass]="{
                    'is-invalid':
                      amendmentForm.get('iSTypeid')?.invalid &&
                      amendmentForm.get('iSTypeid')?.touched,
                  }"
                >
                  <option value="">Select Society Type</option>

                  <option
                    *ngFor="let item of filteredSocietyTypeList"
                    [value]="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>

                <div
                  class="invalid-feedback"
                  *ngIf="
                    amendmentForm.get('iSTypeid')?.invalid &&
                    amendmentForm.get('iSTypeid')?.touched
                  "
                >
                  Society Type is required.
                </div>
              </div>
            </ng-container>

            <div class="col-12" *ngIf="isNewBylaws">
              <label class="form-label"
                >New Bye-laws Details<span class="text-danger">* </span></label
              >
              <div class="textarea-wrapper">
                <textarea
                  rows="3"
                  class="form-control"
                  formControlName="newBylawsDetails"
                  [class]="
                    amendmentForm.get('newBylawsDetails')?.dirty &&
                    amendmentForm.get('newBylawsDetails')?.invalid
                      ? 'invalid'
                      : ''
                  "
                  placeholder="Enter New Bye-laws Details"
                  #newText
                  maxlength="1200"
                ></textarea>

                <div class="char-counter" suffix>
                  {{ newText.value.length }} / {{ newText.maxLength }}
                </div>
              </div>
            </div>
            <div
              style="max-height: 65vh; overflow-y: auto"
              *ngIf="
                amendmentForm.get('sAmmendmentTypeSubject')?.value == 2 &&
                amendmentForm.get('amendmentType')?.value == 3
              "
            >
              <h6 class="election-title"><b>Existing Objectives</b></h6>

              <table class="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th width="20%" class="text-center">S.No.</th>
                    <th>Objective</th>
                    <th width="20%" class="text-center">Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let obj of objectiveList; let i = index">
                    <td class="text-center">{{ i + 1 }}</td>
                    <td>{{ obj.sSocietyObjDes }}</td>
                    <td class="text-center">
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        (click)="deleteObj(obj.iSocietyObjid, obj)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div *ngIf="objectiveList?.length === 0" class="text-muted mb-3">
                No objectives added yet.
              </div>

              <hr />
            </div>
            <div
              class="col-12"
              *ngIf="amendmentForm.get('sAmmendmentTypeSubject')?.value"
            >
              <label class="form-label fw-bold"
                >Select All Applicable Disclaimers<span class="text-danger"
                  >*
                </span></label
              >
              <div formArrayName="checkboxes" class="row g-2">
                <div
                  class="col-md-12"
                  *ngFor="let option of checkboxOptions; let i = index"
                >
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [formControlName]="i"
                      [value]="option.iDisclaimerId"
                    />
                    <span class="form-check-label">{{
                      option.sDisclaimer
                    }}</span>
                  </div>
                </div>
              </div>
              <div
                *ngIf="
                  amendmentForm.get('checkboxes')?.touched &&
                  amendmentForm.get('checkboxes')?.hasError('allRequired')
                "
                class="text-danger mt-2"
              >
                All checkboxes must be selected.
              </div>
            </div>

            <div class="col-12 text-end mt-3">
              <button
                type="button"
                [disabled]="amendmentForm.invalid"
                class="btn btn-success"
                (click)="addAmendment()"
              >
                <i class="bi bi-plus-lg"></i> Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Amendments Table -->
    <div class="card shadow-sm">
      <div class="card-header">
        <h5 class="election-title">🧾 Amendments Details</h5>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-hover table-bordered align-middle">
            <thead class="table-light">
              <tr>
                <th>Sr. No</th>
                <th>Application Subject</th>
                <th>Bye-laws No.</th>
                <!-- <th>Existing Bylaws</th> -->
                <th>New Bye-laws Detail</th>
                <!-- <th *ngIf="showLiabilityColumn()">Liability</th> -->
                <th *ngIf="showPriorDocColumn()">Prior Documents</th>
                <!-- Registration Certificate column removed; view via Action PDF button -->
                <!--
                <th *ngIf="showRegistrarCertificateColumn()">
                  Registration Certificate
                </th>
                -->
                <th>Ammendment Type</th>
                <th width="220">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of amendmentsList; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ typeName(item.sAmmendmentTypeSubject) }}</td>
                <td>{{ item.bylawsNumber }}</td>
                <!-- Existing Bylaws column removed
                <td>
                  <app-read-more
                    text="{{
                      item.existingBylawsDetails
                        ? item.existingBylawsDetails
                        : 'NA'
                    }}"
                    [maxLength]="20"
                    [uniqueId]="i + 1 + 'sCaseBrief'"
                    (viewMore)="viewMore($event)"
                  ></app-read-more>
                </td>
                -->
                <td>
                  <!-- {{ item.newBylawsDetails ?item.newBylawsDetails :'NA' }} -->
                  <app-read-more
                    text="{{
                      item.newBylawsDetails ? item.newBylawsDetails : 'NA'
                    }}"
                    [maxLength]="20"
                    (viewMore)="viewMore($event)"
                  ></app-read-more>
                </td>
                <!-- <td *ngIf="showLiabilityColumn()">{{ item.liabilities == 1 ? 'Yes' : 'No' }}</td> -->
                <td *ngIf="showPriorDocColumn()">
                  {{
                    item.priorApprovalRegistrar?.path
                      ? item.priorApprovalRegistrar?.path
                      : "NA"
                  }}
                </td>
                <!-- Registration Certificate column removed
                <td *ngIf="showRegistrarCertificateColumn()">
                  <span
                    *ngIf="
                      isNameOrAddressAmendment(item.sAmmendmentTypeSubject)
                    "
                  >
                    {{ registrarCertificateLabel(item) }}
                  </span>
                  <span
                    *ngIf="
                      !isNameOrAddressAmendment(item.sAmmendmentTypeSubject)
                    "
                    >—</span
                  >
                </td>
                -->
                <td>
                  {{ getAmendmentActionLabel(item.amendmentType) }}
                </td>
                <td>
                  <button
                    *ngIf="item.priorApprovalRegistrar"
                    type="button"
                    class="btn btn-primary btn-sm me-1"
                    title="View prior approval document"
                    data-bs-toggle="modal"
                    data-bs-target="#AmendmentsAppDetails"
                    (click)="preview(item.priorApprovalRegistrar)"
                  >
                    <i class="bi bi-eye"></i>
                  </button>
                  <button
                    *ngIf="
                      isNameOrAddressAmendment(item.sAmmendmentTypeSubject) &&
                      hasRegistrarCertificate(item)
                    "
                    type="button"
                    class="btn btn-success btn-sm me-1"
                    title="View Registration Certificate"
                    data-bs-toggle="modal"
                    data-bs-target="#AmendmentsAppDetails"
                    (click)="preview(item.registrarCertificate)"
                  >
                    <i class="bi bi-file-earmark-pdf"></i>
                  </button>
                  <button
                    *ngIf="
                      isNameOrAddressAmendment(item.sAmmendmentTypeSubject) &&
                      hasRegistrarCertificate(item)
                    "
                    type="button"
                    class="btn btn-outline-secondary btn-sm me-1"
                    title="Download Registration Certificate"
                    (click)="downloadDocument(item.registrarCertificate)"
                  >
                    <i class="bi bi-download"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-info btn-sm me-1"
                    title="View"
                    data-bs-toggle="modal"
                    data-bs-target="#viewAmendmentModal"
                    (click)="viewDetails(item)"
                  >
                    <i class="bi bi-eye"></i>
                  </button>

                  <!-- Edit -->
                  <button
                    type="button"
                    class="btn btn-warning btn-sm me-1"
                    title="Edit"
                    (click)="editAmendment(item, i)"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteConfirmModal"
                    (click)="setDeleteIndex(i)"
                  >
                    <i class="bi bi-trash3"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="!amendmentsList?.length">
                <td colspan="7" class="text-center text-muted">
                  No amendments added yet.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Read More Model -->
        <div
          class="modal fade animate-fade"
          id="readMoreModal"
          tabindex="-1"
          aria-labelledby="readMoreModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title election-title" id="readMoreModalLabel">
                  Full Text
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  (click)="hideViewMore()"
                ></button>
              </div>
              <div class="modal-body">
                {{ ExpendeText }}
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                  (click)="hideViewMore()"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Delete Confirmation Modal -->
        <div
          class="modal fade"
          id="deleteConfirmModal"
          tabindex="-1"
          aria-labelledby="deleteConfirmModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="election-title" id="deleteConfirmModalLabel">
                  Confirm Delete
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                Are you sure you want to delete this ByLaw ?
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  (click)="confirmDelete()"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="viewAmendmentModal" tabindex="-1">
          <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4">
              <!-- Header -->
              <div
                class="modal-header text-white rounded-top-4 px-4 py-3"
                style="background: linear-gradient(135deg, #0d6efd, #0a58ca)"
              >
                <h5 class="modal-title fw-bold mb-0">
                  <i class="bi bi-file-earmark-text me-2"></i>
                  View Amendment
                </h5>

                <button
                  type="button"
                  class="btn-close btn-close-white"
                  data-bs-dismiss="modal"
                ></button>
              </div>

              <!-- Body -->
              <div class="modal-body p-4">
                <div class="row g-3" *ngIf="selectedAmendment">
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 bg-light h-100">
                      <small class="text-muted d-block mb-1"
                        >Application Subject</small
                      >
                      <strong>
                        {{
                          typeName(selectedAmendment?.sAmmendmentTypeSubject)
                        }}
                      </strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 bg-light h-100">
                      <small class="text-muted d-block mb-1"
                        >Bylaws Number</small
                      >
                      <strong>{{
                        selectedAmendment?.bylawsNumber || "NA"
                      }}</strong>
                    </div>
                  </div>

                  <!-- Existing Bylaws section hidden in view modal
                  <div class="col-md-12">
                    <div class="border rounded-3 p-3">
                      <small class="text-muted d-block mb-1"
                        >Existing Bylaws</small
                      >
                      <strong>{{
                        selectedAmendment?.existingBylawsDetails || "NA"
                      }}</strong>
                    </div>
                  </div>
                  -->

                  <div class="col-md-12">
                    <div class="border rounded-3 p-3">
                      <small class="text-muted d-block mb-1"
                        >New Bylaws Details</small
                      >
                      <strong>{{
                        selectedAmendment?.newBylawsDetails || "NA"
                      }}</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 bg-light h-100">
                      <small class="text-muted d-block mb-1"
                        >Application Type</small
                      >
                      <strong>{{
                        getAmendmentActionLabel(selectedAmendment?.amendmentType)
                      }}</strong>
                    </div>
                  </div>

                  <div
                    class="col-md-12"
                    *ngIf="
                      isNameOrAddressAmendment(
                        selectedAmendment?.sAmmendmentTypeSubject
                      ) && hasRegistrarCertificate(selectedAmendment)
                    "
                  >
                    <div
                      class="border rounded-3 p-3 d-flex flex-wrap align-items-center justify-content-between gap-2"
                    >
                      <div>
                        <small class="text-muted d-block mb-1"
                          >Registration Certificate</small
                        >
                        <strong>{{
                          registrarCertificateLabel(selectedAmendment)
                        }}</strong>
                      </div>
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        data-bs-toggle="modal"
                        data-bs-target="#AmendmentsAppDetails"
                        (click)="preview(selectedAmendment.registrarCertificate)"
                      >
                        <i class="bi bi-file-earmark-pdf me-1"></i>
                        View document
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm"
                        (click)="
                          downloadDocument(
                            selectedAmendment.registrarCertificate
                          )
                        "
                      >
                        <i class="bi bi-download me-1"></i>
                        Download
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Footer -->
              <div class="modal-footer px-4 py-3 bg-light rounded-bottom-4">
                <button
                  type="button"
                  class="btn btn-secondary px-4"
                  data-bs-dismiss="modal"
                >
                  <i class="bi bi-x-circle me-1"></i>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="text-end mt-3">
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="!(amendmentsList.length > 0) || amendmentForm.invalid"
            data-bs-toggle="modal"
            data-bs-target="#confirmationAmendmentModal"
          >
            Apply for Amendments
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- Modal -->
<div
  class="modal fade animate-fade"
  id="confirmationAmendmentModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Confirmation ?</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        Please ensure that all required corrections and updates are completed
        before submitting the application. Once submitted, no further
        modifications will be permitted. We strongly recommend reviewing the
        bylaws carefully prior to proceeding. Would you like to proceed with
        applying for the amendments.

        <p>
          <input id="terms" type="checkbox" #confirmCheck [(ngModel)]="agree" />
          I agree!
        </p>
      </div>
      <div></div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          No
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!agree"
          (click)="submit()"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<div
  class="modal fade"
  id="AmendmentsAppDetails"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="AmendmentsAppDetailsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="AmendmentsAppDetailsLabel">
          Preview file
        </h1>
        <div class="d-flex align-items-center gap-2">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            *ngIf="previewDocument"
            (click)="downloadDocument(previewDocument)"
          >
            <i class="bi bi-download me-1"></i>
            Download
          </button>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="close()"
          ></button>
        </div>
      </div>
      <div class="modal-body">
        <iframe
          [src]="base64Pdf"
          style="width: 100%; height: 60vh; border: none"
        ></iframe>
      </div>
    </div>
  </div>
</div>
